// extracted by mini-css-extract-plugin
module.exports = {"skeletonText":"styles_skeletonText___yA4G","skeletonTextLine":"styles_skeletonTextLine__Bc2RZ","skeletonTextRow":"styles_skeletonTextRow__83lQU"};